import React, { createContext, useRef } from 'react';
import { v4 } from 'uuid';

const ModalContext = /*#__PURE__*/createContext({});
const ModalOrchestratorProvider = _ref => {
  let {
    children
  } = _ref;
  const contextValue = useRef({
    storeKey: v4()
  });
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: contextValue.current
  }, children);
};

export { ModalContext, ModalOrchestratorProvider };
//# sourceMappingURL=ModalOrchestratorProvider.js.map
